export const openTimestamp = (state) => state.spaceSelector.openTimestamp;
export const openCorrelationId = (state) =>
  state.spaceSelector.openCorrelationId;
